module.exports = __webpack_public_path__ + "static/Martina_Achilli-5ae741dda48050cf51daa07c88f140ef.jpg";